module.exports = __webpack_public_path__ + "static/media/25587766_1703513549723829_8489225547972669333_o.8b51ed07.jpg";